const VNode = (props) => {
  return props.vnode
}

VNode.props = ['vnode']

export default VNode